import { createFileRoute } from "@tanstack/react-router";
import {
  DayBeforeInstructions,
  baseReminders,
  prescriptionReminder,
} from "@/components/site/DayBeforeInstructions";

export const Route = createFileRoute("/sms-day-before-denver")({
  head: () => ({
    meta: [
      { title: "Denver SMS Day Before - Restore Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair Denver pre-operative reminders for the day before your FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Pre-Procedure Reminders — Denver | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "What to do — and what to avoid — the day before your RESTORE® Hair Denver FUE procedure.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/sms-day-before-denver/" }],
  }),
  component: () => (
    <DayBeforeInstructions
      reminders={[...baseReminders, prescriptionReminder]}
      phone="(630) 509-7704"
      phoneHref="tel:+16305097704"
    />
  ),
});
